<script setup lang="ts">
import { reactive, watch } from "vue";
import { required } from "@/ui/validation/validationRules";
import { t } from "@/plugins/i18n";

const model = defineModel<Record<string, any>>();

const formState = reactive<Record<string, any>>({ ...model.value });

watch(
	formState,
	(newVal) => {
		model.value = { ...newVal };
	},
	{ deep: true }
);

watch(
	model,
	(newVal) => {
		Object.assign(formState, newVal);
	},
	{ deep: true }
);
</script>

<template>
	<div>
		<div v-for="(v, property) in formState" :key="property" class="mt-5">
			<div class="pb-2">
				<label class="text-h6">
					{{ t(`integrations.form_properties.${property}`) }}:
				</label>
			</div>
			<div class="w-100">
				<v-text-field
					:id="property"
					v-model="formState[property]"
					hide-details="auto"
					variant="filled"
					:rules="[required(t)]"
				></v-text-field>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
